import React from 'react';
import pt from 'prop-types';
import { ListItemButton, ListItemText } from '@metarouter-private/mr-mui';

import getOrgName from './getOrgName';

const PRIMARY_TYPOGRAPHY_PROPS = { noWrap: true, variant: 'body1' };

export default function OrgListItem({ org, switching, switchTo }) {
  const name = getOrgName(org);

  return (
    <ListItemButton data-test-id="OrgSwitcherOption" disabled={switching} title={name} onClick={() => switchTo(org.id)}>
      <ListItemText primary={name} primaryTypographyProps={PRIMARY_TYPOGRAPHY_PROPS} />
    </ListItemButton>
  );
}

OrgListItem.propTypes = {
  org: pt.shape({ id: pt.string.isRequired, display_name: pt.string, name: pt.string }).isRequired,
  switching: pt.bool.isRequired,
  switchTo: pt.func.isRequired,
};
